// 9fbef606107a605d69c0edbcd8029e5d
import { EXTRA_POINTS_ACTION_PATTERN } from '../../../../constants/reducer.constants';

const EXTRA_POINTS_CONSTANTS = {
  FETCH_PROMO_LIST_CONTENT: `${EXTRA_POINTS_ACTION_PATTERN}FETCH_PROMO_LIST_CONTENT`,
  SET_PROMO_LIST_CONTENT: `${EXTRA_POINTS_ACTION_PATTERN}ADD_PROMO_LIST_CONTENT`,
  SHOW_LOADER: `${EXTRA_POINTS_ACTION_PATTERN}SHOW_LOADER`,
  HIDE_LOADER: `${EXTRA_POINTS_ACTION_PATTERN}HIDE_LOADER`,
};

export default EXTRA_POINTS_CONSTANTS;
